// Row and candidate actions are addressed through the DOM rather than refs so focus can be restored
// positionally after a refetch, when the element that was clicked may no longer exist.
const actionsBy = (root: HTMLElement | null, attribute: string) => (
  Array.from(root?.querySelectorAll<HTMLButtonElement>(`[${attribute}]`) ?? [])
);

const actionBy = (root: HTMLElement | null, attribute: string, id: number) => (
  root?.querySelector<HTMLButtonElement>(`[${attribute}="${id}"]`)
);

// Deliberately distinct attributes: the Add panel renders inside the table's root, so one attribute
// would leave the table's post-remove focus counting the panel's buttons as rows.
export const rowActionsIn = (root: HTMLElement | null) => actionsBy(root, 'data-row-action');

export const rowActionFor = (root: HTMLElement | null, id: number) => actionBy(root, 'data-row-action', id);

export const candidateActionsIn = (root: HTMLElement | null) => actionsBy(root, 'data-candidate-action');

export const candidateActionFor = (root: HTMLElement | null, tagId: number) => (
  actionBy(root, 'data-candidate-action', tagId)
);
